import { render, staticRenderFns } from "./SolutionsResults.vue?vue&type=template&id=69d0ef89&scoped=true"
import script from "./SolutionsResults.js?vue&type=script&lang=js&external"
export * from "./SolutionsResults.js?vue&type=script&lang=js&external"
import style0 from "./SolutionsResults.scss?vue&type=style&index=0&id=69d0ef89&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d0ef89",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTag: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Tag/Tag.vue').default,HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default})
